import { render } from "./BbamarketingView.vue?vue&type=template&id=3dae7e4b"
import script from "./BbamarketingView.vue?vue&type=script&lang=js"
export * from "./BbamarketingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__